import { ROUTE_NAMES_RAPIDBOARD_USER_BOARD_VIEW_NOT_FOUND } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const userBoardViewNotFoundRoute: InvariantRoute = {
	name: ROUTE_NAMES_RAPIDBOARD_USER_BOARD_VIEW_NOT_FOUND,
	path: '/jira/people/:accountId/boards/:boardId/not-found',
};
